import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";

const LocalRoutes = ({ children }) => {
  return !Cookies.get("accessToken1") ? children : <Navigate to="/dashboard" />;
};

export default LocalRoutes;
